export const KC_LANES = ['learn', 'help'] as const;
export const KC_PRODUCT_LINES = ['ecf', 'pstx', 'ieo', 'general'] as const;

export type KcLane = typeof KC_LANES[number];
export type KcProductLine = typeof KC_PRODUCT_LINES[number];

/**
 * Joins class fragments. A plain space-join (no clsx/tailwind-merge) keeps this feature-local copy
 * dependency-free — those packages are design-system-only and not on `staging` (ADR-0006). The
 * fragments here are disjoint (base layout/sizing + a non-overlapping colour set), so there is no
 * Tailwind conflict to merge away.
 */
function cn(...inputs: string[]): string {
  return inputs.filter(Boolean).join(' ');
}

const laneIconClasses: Record<KcLane, string> = {
  learn: 'tw-bg-[#e7f0fa] tw-text-[#1f5b8f]',
  help: 'tw-bg-[#C2F0CA] tw-text-[#006927]',
};

const pillClasses: Record<KcProductLine, string> = {
  ecf: 'tw-bg-[#D3E8FF] tw-text-[#3a5e80]',
  pstx: 'tw-bg-[#e3f6ea] tw-text-[#0a7a3b]',
  ieo: 'tw-bg-[#f7e6d8] tw-text-[#a85a22]',
  general: 'tw-bg-[#eef0f2] tw-text-[#555]',
};

export function kcContentCardClasses(lane: KcLane): string {
  return cn('kc-ico', laneIconClasses[lane], 'tw-w-[38px] tw-h-[38px] tw-rounded-[9px] tw-flex tw-items-center tw-justify-center tw-mb-1');
}

export function kcPillClasses(productLine: KcProductLine): string {
  return cn('pl-tag', pillClasses[productLine], 'tw-text-[10.5px] tw-font-bold tw-px-2 tw-py-[2px] tw-rounded-[5px]');
}
